<div class="flex align-items-center justify-content-between mb-3">
  <h2 class="m-0">Please enter the customer details</h2>
  <p-button
    label="Export"
    icon="pi pi-download"
    (onClick)="exportCustomer()"
    [disabled]="!customer || !customer.name"
  ></p-button>
</div>
<form id="customerForm" name="customerForm" role="form" *ngIf="customerFormGroup" [formGroup]="customerFormGroup">
  <div class="formgrid grid">
    <div class="field col-12 md:col-4">
      <label>Domain</label>
      <p-dropdown
        inputId="domain"
        name="domain"
        [options]="domains"
        formControlName="domain"
        optionLabel="description"
        optionValue="domain"
        [filter]="true"
        filterBy="description"
        placeholder="Select a domain"
        *ngIf="!onBoardingId"
        [style]="{ width: '100%' }"
        [ngClass]="{ 'w-full':true,'text-sm': true }"
        (onChange)="onDomainChange($event)"/>
      <input
        pInputText
        id="domain"
        name="domain"
        type="text"
        formControlName="domain"
        *ngIf="onBoardingId"
        [readOnly]="true"
        [ngClass]="{ 'w-full':true,'text-sm': true}"/>
      <ul
        class="error-form-text"
        *ngIf="isControlInvalid('domain')">
        <li>This field is required</li>
      </ul>
    </div>
    <div class="field col-12 md:col-4">
      <label for="name">Billing name</label>
      <div class="relative">
        <input
          pInputText
          id="name"
          name="name"
          type="text"
          formControlName="name"
          [ngClass]="{ 'w-full':true,'text-sm': true, 'ng-invalid': isControlInvalid('name') }"
          [required]="true"/>
        <i *ngIf="checkingCustomer" class="pi pi-spin pi-spinner absolute right-2 top-2 text-500"></i>
      </div>
      <ul
        class="error-form-text"
        *ngIf="isControlInvalid('name')">
        <li>This field is required</li>
      </ul>
      <div *ngIf="customerExistsWarning && existingCustomers.length > 0" class="mt-2 p-2 surface-100 border-round border-left-3 border-orange-500">
        <div class="flex align-items-center gap-2 mb-1">
          <i class="pi pi-exclamation-triangle text-orange-500"></i>
          <span class="font-semibold text-orange-700 text-sm">Customer Already Exists in Rev.io</span>
        </div>
        <p class="text-sm text-700 m-0 mb-2">
          A customer with this name already exists in Rev.io. Creating a new customer is not allowed to avoid duplicate customers and sites.
        </p>
        <div class="text-sm text-600">
          <strong>Existing customers:</strong>
          <ul class="m-0 mt-1 pl-4">
            <li *ngFor="let cust of existingCustomers">
              {{ cust.customerName }} (ID: {{ cust.customerId }})
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="field col-12 md:col-4">
      <label for="email" style="display:block">Email</label>
      <input
        pInputText
        id="email"
        name="email"
        type="text"
        formControlName="email"
        [ngClass]="{ 'w-full':true,'text-sm': true, 'ng-invalid': isControlInvalid('email') }"
        [attr.aria-required]="isEmailRequired()"/>
      <ul
        class="error-form-text"
        *ngIf="isControlInvalid('email')">
        <li *ngIf="isEmailRequired() && customerFormGroup.get('email')?.hasError('required')">This field is required</li>
        <li *ngIf="customerFormGroup.get('email')?.hasError('email')">Must be a valid email</li>
      </ul>
    </div>
    <div class="field col-12 md:col-6">
      <label for="name">Address line 1</label>
      <input
        pInputText
        id="addressLineOne"
        name="addressLineOne"
        type="text"
        formControlName="addressLineOne"
        [ngClass]="{ 'w-full':true,'text-sm': true, 'ng-invalid': isControlInvalid('addressLineOne') }"
        [required]="true"/>
      <ul
        class="error-form-text"
        *ngIf="isControlInvalid('addressLineOne')">
        <li>This field is required</li>
      </ul>
    </div>
    <div class="field col-12 md:col-6">
      <label for="addressLineTwo">Address line 2</label>
      <input
        pInputText
        id="addressLineTwo"
        name="addressLineTwo"
        type="text"
        formControlName="addressLineTwo"
        class="w-full text-sm"
        placeholder="Apartment, suite, etc. (optional)"/>
    </div>
    <div class="field col-12 md:col-4">
      <label for="state" style="display:block">State</label>
      <p-dropdown
        inputId="state"
        name="state"
        [options]="states"
        formControlName="state"
        optionLabel="name"
        [filter]="true"
        filterBy="name"
        placeholder="Select a state"
        [style]="{ width: '100%' }"
        [ngClass]="{ 'w-full':true,'text-sm': true }"
        (onChange)="onStateChange($event)"/>
    </div>
    <div class="field col-12 md:col-4">
      <label for="city" style="display:block">City</label>
      <p-dropdown
        inputId="city"
        name="city"
        [options]="cities"
        formControlName="city"
        optionLabel="name"
        placeholder="Select a city"
        [filter]="true"
        filterBy="name"
        [style]="{ width: '100%' }"
        [ngClass]="{ 'w-full':true,'text-sm': true }"
        (onChange)="onCityChange($event)"/>
    </div>
    <div class="field col-12 md:col-4">
      <label for="zipCode" style="display:block">Zip Code</label>
      <input
        pInputText
        id="zipCode"
        name="zipCode"
        type="text"
        pattern="[0-9]{5}"
        formControlName="zipCode"
        [ngClass]="{ 'w-full':true,'text-sm': true, 'ng-invalid': isControlInvalid('zipCode') }"
        [required]="true"/>
      <ul
        class="error-form-text"
        *ngIf="isControlInvalid('zipCode')">
        <li>This field is required</li>
        <li>Only numbers allowed</li>
        <li>5 digits are mandatory</li>
      </ul>
    </div>
    <div class="field col-12 md:col-6">
      <label>Customer class</label>
      <p-selectButton
        id="customerClassSelect"
        name="customerClassSelect"
        [styleClass]="'text-sm'"
        [options]="customerClassValues"
        formControlName="customerClass"
        optionLabel="label"
        optionValue="value"
        [allowEmpty]="false"
        dataKey="value"
        (onChange)="onCustomerClassChange($event)"/>
    </div>
    <div class="field col-12 md:col-4">
      <label>Billing method</label>
      <p-selectButton
        id="billingMethodSelect"
        name="billingMethodSelect"
        [styleClass]="'text-sm'"
        [options]="billingMethodValues"
        formControlName="billingMethod"
        optionLabel="label"
        optionValue="value"
        [allowEmpty]="false"
        dataKey="value"
        (onChange)="onBillingMethodChange($event)"/>
    </div>
    <div class="field col-12 md:col-2">
      <label for="masId" style="display:block">MAS ID</label>
      <input
        pInputText
        id="masId"
        name="masId"
        type="text"
        formControlName="masId"
        class="w-full text-sm"
        placeholder="Optional"/>
    </div>
  </div>
</form>
<app-client-onboarding-wizard-buttons
  *ngIf="customerFormGroup"
  [nextDisabled]="!customerFormGroup.valid || (customerExistsWarning && existingCustomers.length > 0)"
  (buttonClicked)="handleCommonButtonClicked($event)"></app-client-onboarding-wizard-buttons>
<p-confirmDialog/>

<!-- Customer Exists Dialog -->
<p-dialog
  [(visible)]="showCustomerExistsDialog"
  header="Customer Already Exists in Rev.io"
  [modal]="true"
  [style]="{ width: '600px' }"
  [closable]="true"
  (onHide)="onCustomerExistsDialogClose()"
  [contentStyle]="{ overflow: 'auto', maxHeight: '80vh', padding: '1.5rem' }"
>
  <div class="flex flex-column gap-3">
    <div class="p-3 surface-100 border-round border-left-3 border-orange-500">
      <div class="flex align-items-center gap-2 mb-2">
        <i class="pi pi-exclamation-triangle text-orange-500"></i>
        <span class="font-semibold text-orange-700">Warning</span>
      </div>
      <p class="text-sm text-700 m-0">
        A customer with the name <strong>"{{ customerFormGroup.get('name')?.value }}"</strong> already exists in Rev.io. Creating a new customer is not allowed.
      </p>
    </div>

    <div *ngIf="existingCustomers && existingCustomers.length > 0" class="flex flex-column gap-2 mb-3">
      <p class="font-semibold m-0 mb-2">Existing customers found ({{ existingCustomers.length }}):</p>
      <div class="p-3 surface-100 border-round">
        <ul class="m-0 pl-4">
          <li *ngFor="let cust of existingCustomers; trackBy: trackByCustomerId" class="mb-2">
            <strong>{{ cust.customerName }}</strong> <span class="text-600">(ID: {{ cust.customerId }})</span>
          </li>
        </ul>
      </div>
    </div>
    <div *ngIf="!existingCustomers || existingCustomers.length === 0" class="p-2 text-600">
      <p class="text-sm m-0">No customer details available.</p>
    </div>

    <div class="p-3 surface-100 border-round">
      <p class="text-sm text-700 m-0">
        <strong>Important:</strong> Creating a new customer when one already exists is not allowed. It would create a duplicate customer and potentially duplicate sites in Rev.io.
      </p>
    </div>

    <div class="p-3 surface-100 border-round border-left-3 border-blue-500">
      <p class="text-sm text-700 m-0">
        <strong>Recommendation:</strong> If you need to add new sites to an existing customer, please use the <strong>"NS ↔ Rev.io"</strong> sync feature (located in the Billing menu) instead of creating a new customer.
      </p>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="flex justify-content-end">
      <p-button
        label="Close"
        severity="secondary"
        (onClick)="onCustomerExistsDialogClose()"
      ></p-button>
    </div>
  </ng-template>
</p-dialog>
